import React from 'react';
import './Blog.css';

function Blog() {
  return (
    <div className="blog-container">
      <h1>My Blog</h1>
      <p>Welcome to my blog! Here you can find articles and posts about various topics.</p>
    </div>
  );
}

export default Blog;
